import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import React from 'react';
import { AccountUtils } from '@shared/commons/cache/AccountUtils';
import { getAccountModeStyle, getAccountModeText } from '@shared/utils/cache/Accounts/accounts.utils';
import { InstrumentTypeLogo } from '../../elements/InstrumentTypeLogo';
export class AccountContextMenuItem extends React.Component {
    constructor() {
        super(...arguments);
        this.ref = React.createRef();
        this.onClick = () => {
            const item = this.props.item;
            if (!isNullOrUndefined(item.event)) {
                if (this.props.item.canCheck) {
                    item.checked = !item.checked;
                    this.forceUpdate();
                }
                item.event(item);
            }
            if (!this.props.item.canCheck) {
                this.props.onCloseContextMenu();
            }
        };
    }
    render() {
        const activeStyle = this.props.item.selected ? ' _active' : '';
        const disabledStyle = this.props.item.enabled === false ? ' _disabled' : '';
        const account = this.props.item.value;
        const maxAccountModeWidth = this.props.accountModeWidth;
        return (_jsx("div", { className: `new-context-menu-row${activeStyle}${disabledStyle}`, ref: this.ref, onClick: this.onClick, children: _jsxs("div", { className: "new-context-menu-item small-gap", children: [this.renderCheckedIcon(), _jsx("div", { className: "new-context-menu-item-account-mode", style: {
                            width: maxAccountModeWidth,
                            minWidth: maxAccountModeWidth,
                            maxWidth: maxAccountModeWidth
                        }, children: _jsx("div", { className: `accountWidget-headerButton-${getAccountModeStyle(account)}`, children: getAccountModeText(account) }) }), this.renderInstrumentType(), _jsx("div", { className: "new-context-menu-item-text-container", children: _jsx("div", { className: "new-context-menu-item-text-container-text", children: account.toString(true) }) })] }) }, account.userPin));
    }
    renderCheckedIcon() {
        if (!this.props.item.canCheck) {
            return null;
        }
        const icon = this.props.item.checked ? (_jsx("svg", { children: _jsx("use", { xlinkHref: "assets/webdesktop/web-desktop-sprite.svg#accept" }) })) : null;
        return _jsx("div", { className: "new-context-menu-item-icon", children: icon });
    }
    renderInstrumentType() {
        if (!this.props.isVisibleInstrumentType) {
            return null;
        }
        const account = this.props.item.value;
        const accountInstrumentStyle = {};
        if (!AccountUtils.needAddType(account)) {
            accountInstrumentStyle.visibility = 'hidden';
        }
        return (_jsx("div", { className: "new-context-menu-item-account-instrument", style: accountInstrumentStyle, children: _jsx(InstrumentTypeLogo, { instrumentType: account.PreferredInstrumentType }) }));
    }
}
